import { AlertCircle, Check } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

const tones = {
  warning: { box: 'bg-amber-50 border-amber-200 text-amber-800', icon: 'text-amber-600', Icon: AlertCircle },
  info: { box: 'bg-white/90 border-blue-200 text-blue-900', icon: 'text-blue-600', Icon: Check },
} as const;

export function Alert({
  tone = 'warning',
  className,
  children,
}: {
  tone?: keyof typeof tones;
  className?: string;
  children: ReactNode;
}) {
  const { box, icon, Icon } = tones[tone];
  return (
    <div
      role={tone === 'warning' ? 'alert' : 'status'}
      className={cn('p-3 rounded-xl border text-xs flex items-start gap-2', box, className)}
    >
      <Icon className={cn('w-4 h-4 flex-shrink-0 mt-0.5', icon)} />
      <span>{children}</span>
    </div>
  );
}
